import {LeaderboardUser} from '@dms/api/settings';

import {PayPerUseOperationColumn} from './getOperationTypeColumns';
import {zeroFillUserOperationCounts} from './zeroFillUserOperationCounts';

export interface LabeledOperationColumn extends PayPerUseOperationColumn {
  label: string;
}

export interface LeaderboardExportRow {
  cells: string[];
}

export interface LeaderboardExportTable {
  // Header row, in display order.
  columns: string[];
  // One entry per row; cells aligned to columns.
  rows: LeaderboardExportRow[];
}

interface BuildLeaderboardExportTableParams {
  // Users exactly as rendered — already filtered and sorted (and pre-pagination,
  // so the export covers the whole filtered set, not just the visible page).
  users: LeaderboardUser[];
  // Currently visible operation columns, labeled and in display order.
  columns: LabeledOperationColumn[];
  userColumnLabel: string;
  totalColumnLabel: string;
}

/**
 * Builds the export table ("export the view"): the header row plus one row per
 * user, cells aligned to columns. Counts and totals are stringified as raw
 * numbers (not locale-formatted) so spreadsheet tools treat them as numbers.
 * `buildLeaderboardCsv` serializes the returned table to CSV bytes.
 */
export const buildLeaderboardExportTable = (
  params: BuildLeaderboardExportTableParams
): LeaderboardExportTable => {
  const columns = [
    params.userColumnLabel,
    ...params.columns.map((column) => column.label),
    params.totalColumnLabel,
  ];

  const rows = params.users.map((user) => {
    const counts = zeroFillUserOperationCounts(user, params.columns);

    return {
      cells: [
        user.label,
        ...params.columns.map((column) => counts[column.key].toString()),
        user.total.toString(),
      ],
    };
  });

  return {columns, rows};
};
